// extracted by mini-css-extract-plugin
module.exports = {"infoContainer":"_364E0iEhfeEgtVIvGbxW4","block":"_247OdTBiJolTna2VaJrAMm","blockName":"qw7QgDV264NOed-7zC-s","blockValue":"_76Vy92Y8WfFkrzUZ24-Lm"};